'use client';
import { Box, Flex, useRadioGroup } from '@chakra-ui/react';

import CustomRadioButton from '@/app/_components/custom-radio-button/CustomRadioButton';
import { MONTHLYPAYMENTTERM } from '@/constants/payment-method/payment.constants';
const MonthlyPaymentTermButtons = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  const { getRadioProps, getRootProps } = useRadioGroup({
    defaultValue: value,
    onChange: onChange,
  });

  return (
    <Box {...getRootProps()}>
      <Flex gap={'8px'}>
        {MONTHLYPAYMENTTERM.map((value, index) => {
          return (
            <CustomRadioButton
              key={index}
              radioValue={value}
              size={'sm'}
              {...getRadioProps({ value: value })}
            />
          );
        })}
      </Flex>
    </Box>
  );
};

export default MonthlyPaymentTermButtons;
